module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<div class="cart-items">\n\n	';
 if ( itemsCount ) { 
__p+='\n		<h3 class="count">'+
((__t=( paginationInfo ))==null?'':__t)+
'</h3>\n	';
 } 
__p+='\n\n\n	<div class="cart-list">\n	';
 if ( itemsCount ) { 
__p+='\n		';
 _.each(items, function(item) { 
__p+='\n\n			<div class="cart-item">\n				<div class="image">\n					';
 if ( item.image ) { 
__p+='<img src="https://tramino.s3.amazonaws.com'+
((__t=( item.image ))==null?'':__t)+
'" width="100" height="60"/>';
 } 
__p+='\n				</div>\n				<div class="info">\n					<h5>'+
((__t=( item.item_client_name ))==null?'':__t)+
'</h5>\n					<h4>'+
((__t=( item.name ))==null?'':__t)+
'</h4>\n					';
 if ( item.von ) { 
__p+='\n						';
 if ( item.von == item.bis || item.bis == "" ) { 
__p+='\n							<div class="period">'+
((__t=( moment( item.von, "YYYY-MM-DD").format("L") ))==null?'':__t)+
'</div>\n						';
 } else { 
__p+='\n							<div class="period">'+
((__t=( moment( item.von, "YYYY-MM-DD").format("L") ))==null?'':__t)+
' - '+
((__t=( moment( item.bis, "YYYY-MM-DD").format("L") ))==null?'':__t)+
'</div>\n						';
 }
__p+='\n					';
 }
__p+='\n					';
 if ( item.facts ) { 
__p+='<span class="facts">'+
((__t=( item.facts ))==null?'':__t)+
'</span>';
 } 
__p+='\n					';
 if ( item.inclusive ) { 
__p+=' <span class="inkl">'+
((__t=( Translator.get('inkl') ))==null?'':__t)+
' '+
((__t=( item.inclusive ))==null?'':__t)+
'</span>';
 } 
__p+='\n					\n				</div>\n				<div class="price">\n					<div data-id="'+
((__t=( item.id ))==null?'':__t)+
'" class="items-remove">'+
((__t=( __('remove') ))==null?'':__t)+
'</div>\n					<div class="amount">'+
((__t=( Translator.currency(  item.preis_gesamt, "EUR" ) ))==null?'':__t)+
'</div>\n					';
 if ( item.zzgl ) { 
__p+='<div class="exkl">'+
((__t=( Translator.get('zzgl') ))==null?'':__t)+
' '+
((__t=( item.zzgl ))==null?'':__t)+
'</div>';
 } 
__p+='\n				</div>\n				<div class="clear"></div>\n			</div>\n\n		';
 }); 
__p+='\n	';
 } else { 
__p+='\n		<div class="notification">'+
((__t=( __('cart_empty') ))==null?'':__t)+
'</div>\n	';
 } 
__p+='\n	</div>\n\n	<div class="paginator">\n		';
 if ( hasNext ) { 
__p+='<a href="" class="items-next">'+
((__t=( __('next') ))==null?'':__t)+
' &rarr;</a>';
 } 
__p+='\n		';
 if ( hasPrev ) { 
__p+='<a href="" class="items-prev">&larr; '+
((__t=( __('prev') ))==null?'':__t)+
'</a>';
 } 
__p+='\n	</div>\n\n</div>\n\n';
}
return __p;
};


//////////////////
// WEBPACK FOOTER
// /Users/bm/app/code/jsapps/modules/reserva/templates/header/cart-items-template.html
// module id = 53
// module chunks = 0